//Import Libraires
import React, { createContext, useState, useLayoutEffect } from "react";
import { toast } from "react-toastify";

// utils
import { getUserLocation } from "src/utils/requests";

//Create Context
const UserContext = createContext();

/** Note:
 * This context  will be remove in future.
 */
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);
  const [userLocation, setUserLocation] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isCurrentLocation, setIsCorrectLocation] = useState(false);

  const [staleCategory, setStaleCategory] = useState(null); // not part of user

  useLayoutEffect(() => {
    if (localStorage.getItem("eventmoon-user")) {
      setUser(JSON.parse(localStorage.getItem("eventmoon-user")));
    } else {
      if (localStorage.getItem("location")) {
        setUserLocation(JSON.parse(localStorage.getItem("location")));
        setUser(null);
      } else {
        getUserLocation()
          .then((res) => {
            if (res.status === 200) {
              console.log(res);
              if (res.data.country_code2.toLowerCase() === "us")
                saveLocationToLS(res.data);
              else
                saveLocationToLS({
                  latitude: "36.114647",
                  longitude: "-115.172813",
                  city: "Las Vegas",
                  country: res.data.country_name,
                  isDefault: true,
                });
              setUser(null);
            } else {
              toast.error(res.statusText);
            }
          })
          .catch((err) => {
            toast.error(err);
          });
      }
    }

    if (localStorage.getItem("is-current")) setIsCorrectLocation(true);
    clearLocalStorage();

    setIsLoading(false);
  }, []);

  const setUserData = (_user) => {
    setUser({
      location: userLocation,
      ..._user,
    });
    localStorage.setItem(
      "eventmoon-user",
      JSON.stringify({
        location: userLocation,
        ..._user,
      })
    );
  };

  const saveLocationToLS = (_data) => {
    let data = {
      lat: _data.latitude,
      lng: _data.longitude,
      city: _data.city,
    };

    if (_data?.isDefault) {
      data = {
        ...data,
        country: _data.country,
        isDefault: true,
      };
    }

    setUserLocation(data);
    localStorage.setItem("location", JSON.stringify(data));
  };

  const updateUserLocation = (_lat, _lng, _city, _check) => {
    let data = {
      ...userLocation,
      lat: _lat.toString(),
      lng: _lng.toString(),
      city: _city,
    };

    localStorage.setItem("location", JSON.stringify(data));
    if (_check) localStorage.setItem("is-current", true);

    if (!user) {
      setUserLocation(data);
    } else {
      console.log("update user", data);

      localStorage.setItem(
        "eventmoon-user",
        JSON.stringify({
          ...user,
          location: data,
        })
      );

      setUser({
        ...user,
        location: data,
      });
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("eventmoon-user");
    setUserLocation(JSON.parse(localStorage.getItem("location")));
  };

  const clearLocalStorage = () => {
    if (localStorage.getItem("location-new"))
      localStorage.removeItem("location-new");

    if (localStorage.getItem("is-current-new"))
      localStorage.removeItem("is-current-new");

    if (localStorage.getItem("eventmoon-user-new"))
      localStorage.removeItem("eventmoon-user-new");
  };

  return (
    <UserContext.Provider
      value={{
        user,
        setUserData,
        userLocation,
        isLoading,
        isCurrentLocation,
        logout,
        updateUserLocation,
        staleCategory,
        setStaleCategory,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
